exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2y1UGcMmoA_zMzXkmzSUKT{height:81px;width:516px;object-fit:cover}.Gzm7vPnpZHdJhgxJYzI47{border:2px solid #e0e0e0;border-radius:50%;display:block;margin:0 auto;background:#fff;object-fit:cover}\n", ""]);

// Exports
exports.locals = {
	"cover": "_2y1UGcMmoA_zMzXkmzSUKT",
	"plusIcon": "Gzm7vPnpZHdJhgxJYzI47"
};